var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { gql, useQuery } from '@apollo/client';
export var FEATURE_FLAGS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query getFeatureFlagSettings($key: String, $preview: Boolean) {\n    settings(key: $key, preview: $preview) {\n      name\n      key\n      resources {\n        __typename\n        ... on BooleanResource {\n          key\n          label\n          bool: value\n        }\n      }\n    }\n  }\n"], ["\n  query getFeatureFlagSettings($key: String, $preview: Boolean) {\n    settings(key: $key, preview: $preview) {\n      name\n      key\n      resources {\n        __typename\n        ... on BooleanResource {\n          key\n          label\n          bool: value\n        }\n      }\n    }\n  }\n"])));
/**
 * Determine if the feature flag is enabled (SERVER-SIDE)
 */
export var getIsFeatureFlagEnabled = function (testKey, featureFlags) {
    return featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.some(function (flag) { return (flag === null || flag === void 0 ? void 0 : flag.key) === testKey && (flag === null || flag === void 0 ? void 0 : flag.bool) === true; });
};
export var getFeatureFlags = function (options, client) { return __awaiter(void 0, void 0, void 0, function () {
    var data, featureFlags;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, client.query({
                    query: FEATURE_FLAGS,
                    errorPolicy: 'all',
                    variables: {
                        key: 'feature_flags',
                        preview: options.preview
                    },
                    context: {
                        debugLogs: options.debugLogs
                    }
                })];
            case 1:
                data = (_b.sent()).data;
                featureFlags = (_a = data === null || data === void 0 ? void 0 : data.settings[0]) === null || _a === void 0 ? void 0 : _a.resources;
                return [2 /*return*/, featureFlags];
        }
    });
}); };
/**
 * Util function to determine if a feature flag is enabled
 */
export var isFeatureFlagEnabled = function (featureKey_1, client_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([featureKey_1, client_1], args_1, true), void 0, function (featureKey, client, options) {
        var featureFlags;
        if (options === void 0) { options = { preview: false, debugLogs: '' }; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getFeatureFlags(options, client)];
                case 1:
                    featureFlags = _a.sent();
                    return [2 /*return*/, getIsFeatureFlagEnabled(featureKey, featureFlags)];
            }
        });
    });
};
var isBrowser = function () { return typeof window !== 'undefined'; };
/**
 * Hook to determine if a Contentful feature flag is enabled
 */
var useContentfulFeature = function (featureKey, options) {
    var _a;
    if (options === void 0) { options = { preview: false, debugLogs: '' }; }
    var data = useQuery(FEATURE_FLAGS, {
        errorPolicy: 'all',
        variables: {
            key: 'feature_flags',
            preview: options.preview
        },
        context: {
            debugLogs: options.debugLogs
        }
    }).data;
    var urlParams = isBrowser()
        ? new URLSearchParams(window.location.search)
        : null;
    var isForced = urlParams && urlParams.get('featureFlag') === featureKey;
    if (isForced)
        return true;
    var isEnabled = getIsFeatureFlagEnabled(featureKey, (_a = data === null || data === void 0 ? void 0 : data.settings[0]) === null || _a === void 0 ? void 0 : _a.resources);
    return isEnabled;
};
export default useContentfulFeature;
var templateObject_1;
